"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.round = exports.multiply = exports.add = void 0;
const tslib_1 = require("tslib");
const decimal_js_1 = tslib_1.__importDefault(require("decimal.js"));
function add(a, b) {
    const aDec = new decimal_js_1.default(a);
    const bDec = new decimal_js_1.default(b);
    return aDec.add(bDec).toNumber();
}
exports.add = add;
function multiply(a, b) {
    const aDec = new decimal_js_1.default(a);
    const bDec = new decimal_js_1.default(b);
    return aDec.mul(bDec).toNumber();
}
exports.multiply = multiply;
function round(a) {
    const aDec = new decimal_js_1.default(a);
    return aDec.toDecimalPlaces(2).toNumber();
}
exports.round = round;
//# sourceMappingURL=currency-math.js.map